import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/myimg_upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-793be368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload_box" }
const _hoisted_2 = {
  key: 0,
  class: "hover_box"
}
const _hoisted_3 = { class: "img_box" }
const _hoisted_4 = { class: "img_hover" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "up_text"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上传照片", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { style: {"height":"480px","display":"flex"} }
const _hoisted_11 = { class: "modal_left" }
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "add_img"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击上传", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

import { message, Upload, Button, Modal } from 'ant-design-vue';
import { getToken } from '@/plugins/cookie';
import { withDefaults, ref, watch } from 'vue';
import { PlusOutlined, LoadingOutlined, DeleteOutlined, CloseOutlined } from '@ant-design/icons-vue';
import VuePictureCropper, { cropper } from 'vue-picture-cropper';

interface Props {
  fileList: any;
  name?: any;
  listType?: any;
  showList?: boolean;
  accept?: string;
  action?: string;
  headers?: any;
  beforeUpload?: (...args: any[]) => any;
  handleChange?: (...args: any[]) => any;
  loading?: boolean;
  imageName?: string;
  clickStop?: (...args: any[]) => any;
  mask?: boolean;
  plus?: boolean;
  uploadText?: boolean;
  isShowDialog?: boolean;
  cancelChange?: (...args: any[]) => any;
  clearChange?: (...args: any[]) => any;
  resetChange?: (...args: any[]) => any;
  getResultChange?: (...args: any[]) => any;
  pic?: string;
  multiple?: boolean;
  selectUrl?: any;
  beforeUploads?: (...args: any[]) => any;
  handleChanges?: (...args: any[]) => any;
  imageUrls?: string;
  determine?: (...args: any[]) => any;
  confirmLoading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CUploadCropper',
  props: {
    fileList: { default: [] },
    name: { default: 'images' },
    listType: { default: 'picture-card' },
    showList: { type: Boolean, default: false },
    accept: null,
    action: null,
    headers: null,
    beforeUpload: null,
    handleChange: null,
    loading: { type: Boolean, default: false },
    imageName: { default: '' },
    clickStop: null,
    mask: { type: Boolean, default: true },
    plus: { type: Boolean, default: true },
    uploadText: { type: Boolean, default: true },
    isShowDialog: { type: Boolean, default: false },
    cancelChange: null,
    clearChange: null,
    resetChange: null,
    getResultChange: null,
    pic: { default: '' },
    multiple: { type: Boolean, default: false },
    selectUrl: { default: [] },
    beforeUploads: null,
    handleChanges: null,
    imageUrls: { default: '' },
    determine: null,
    confirmLoading: { type: Boolean, default: false }
  },
  emits: ['click:index', 'click:del'],
  setup(__props: any, { emit }) {

const props = __props as { fileList: any, name: any, listType: any, showList: boolean, accept?: string, action?: string, headers?: any, beforeUpload?: (...args: any[]) => any, handleChange?: (...args: any[]) => any, loading: boolean, imageName: string, clickStop?: (...args: any[]) => any, mask: boolean, plus: boolean, uploadText: boolean, isShowDialog: boolean, cancelChange?: (...args: any[]) => any, clearChange?: (...args: any[]) => any, resetChange?: (...args: any[]) => any, getResultChange?: (...args: any[]) => any, pic: string, multiple: boolean, selectUrl: any, beforeUploads?: (...args: any[]) => any, handleChanges?: (...args: any[]) => any, imageUrls: string, determine?: (...args: any[]) => any, confirmLoading: boolean };

const aUpload = Upload;
const token = getToken();


const visible = ref(false);
const pic = ref<string>();
watch(
  () => props.isShowDialog,
  () => {
    visible.value = props.isShowDialog;
  }
);
const clearChange = () => {
  cropper.clear();
};
const resetChange = () => {
  cropper.reset();
};


const clickUrl = (item: any, index: number) => {
  pic.value = item;
  emit('click:index', index);
};
watch(
  () => props.pic,
  () => {
    pic.value = props.pic;
  }
);

const clickDel = (index: number) => {
  emit('click:del', index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(aUpload), {
      "v-model:file-list": props.fileList,
      name: props.name,
      "show-upload-list": props.showList,
      multiple: props.multiple,
      accept: ".jpg,.jpeg,.png,.gif",
      action: "/api/v1/common/upload_images",
      headers: { token: _unref(token) },
      "before-upload": props.beforeUpload,
      onChange: props.handleChange,
      uploadText: props.uploadText,
      class: "ant_upload"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (props.imageName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(PlusOutlined), { class: "CIon" }),
                    _createVNode(_unref(DeleteOutlined), {
                      id: "disable",
                      onClick: _withModifiers(__props.clickStop, ["stop"])
                    }, null, 8, ["onClick"])
                  ])
                ], 512), [
                  [_vShow, props.mask]
                ]),
                _renderSlot(_ctx.$slots, "image", {}, () => [
                  (props.imageName)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "upload_img",
                        src: props.imageName
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (props.loading)
                  ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createVNode(_unref(PlusOutlined), null, null, 512), [
                        [_vShow, props.plus]
                      ]),
                      _renderSlot(_ctx.$slots, "uploadImg", {}, () => [
                        _withDirectives(_createElementVNode("div", null, _hoisted_9, 512), [
                          [_vShow, props.uploadText]
                        ])
                      ])
                    ]))
              ]))
        ])
      ]),
      _: 3
    }, 8, ["v-model:file-list", "name", "show-upload-list", "multiple", "headers", "before-upload", "onChange", "uploadText"]),
    _createVNode(_unref(Modal), {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "自定义上传",
      centered: "",
      maskClosable: false,
      width: "1050px",
      onCancel: props.cancelChange
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          onClick: props.cancelChange
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), { onClick: clearChange }, {
          default: _withCtx(() => [
            _createTextVNode("清除")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), { onClick: resetChange }, {
          default: _withCtx(() => [
            _createTextVNode("重置")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "primary",
          onClick: props.getResultChange
        }, {
          default: _withCtx(() => [
            _createTextVNode("裁切")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          type: "primary",
          onClick: props.determine,
          loading: props.confirmLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectUrl, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "box"
              }, [
                _createElementVNode("img", {
                  src: item,
                  style: {"width":"100%"},
                  onClick: ($event: any) => (clickUrl(item, index))
                }, null, 8, _hoisted_12),
                _withDirectives(_createElementVNode("div", {
                  class: "del",
                  onClick: ($event: any) => (clickDel(index))
                }, "×", 8, _hoisted_13), [
                  [_vShow, props.selectUrl.length > 1]
                ])
              ]))
            }), 128)),
            _createVNode(_unref(aUpload), {
              "v-model:file-list": props.fileList,
              name: props.name,
              "show-upload-list": props.showList,
              multiple: props.multiple,
              accept: ".jpg,.jpeg,.png,.gif",
              action: "/api/v1/common/upload_images",
              headers: { token: _unref(token) },
              "before-upload": props.beforeUploads,
              onChange: props.handleChanges
            }, {
              default: _withCtx(() => [
                (props.imageUrls)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: props.imageUrls,
                      alt: "avatar"
                    }, null, 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
              ]),
              _: 1
            }, 8, ["v-model:file-list", "name", "show-upload-list", "multiple", "headers", "before-upload", "onChange"])
          ]),
          _createVNode(_unref(VuePictureCropper), {
            boxStyle: {
          width: '530px',
          height: '100%',
          backgroundColor: '#f8f8f8',
        },
            img: pic.value,
            options: {
          viewMode: 1,
          dragMode: 'crop',
          autoCrop: false,
        }
          }, null, 8, ["img"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}
}

})